export default "__VITE_ASSET__wc0r5Kf8__"